module.exports = __webpack_public_path__ + "img/vehicle-slides-backdrop-cjdr.516a0cba.jpg";